/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Parent types - entity types that can receive emoji reactions.
 * @export
 */
export const InternalCommonParentTypes = {
    AdminEvent: 'admin_event',
    Article: 'article',
    Comment: 'comment',
    ForumDiscussion: 'forum_discussion',
    Location: 'location',
    MediaCenterFile: 'media_center_file',
    News: 'news',
    Opportunity: 'opportunity',
    Post: 'post',
    Project: 'project',
    User: 'user',
    UserEvent: 'user_event'
};
export function instanceOfInternalCommonParentTypes(value) {
    for (const key in InternalCommonParentTypes) {
        if (Object.prototype.hasOwnProperty.call(InternalCommonParentTypes, key)) {
            if (InternalCommonParentTypes[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function InternalCommonParentTypesFromJSON(json) {
    return InternalCommonParentTypesFromJSONTyped(json, false);
}
export function InternalCommonParentTypesFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InternalCommonParentTypesToJSON(value) {
    return value;
}
export function InternalCommonParentTypesToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
